import type { LayerSpec } from '@/core/pipeline';
import { parseHex } from '@/lib/color';

type SolidParams = { color: string };

export const solidSpec: LayerSpec = {
  kind: 'solid',
  category: 'generator',
  animated: false,
  label: 'Solid',
  defaults: { color: '#ff5a1f' } satisfies SolidParams,
  schema: {
    color: { type: 'color', label: 'Color', default: '#ff5a1f' },
  },
  run: (_input, params, ctx) => {
    const p = params as SolidParams;
    const rgb = parseHex(p.color) ?? ([255, 90, 31] as const);
    const out = new ImageData(ctx.width, ctx.height);
    const data = out.data;
    for (let i = 0; i < data.length; i += 4) {
      data[i]     = rgb[0];
      data[i + 1] = rgb[1];
      data[i + 2] = rgb[2];
      data[i + 3] = 255;
    }
    return out;
  },
};
